import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";

export default withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  // & is actually a concatenate operator
  // Think of "& $thumb" as ".disabled .thumb"
  disabled: {
    "& $thumb": {
      border: "1px solid #C4C4C4",
      backgroundColor: "#F4F4F4",
    },
  },
  switchBase: {
    // // ".SwitchBase.disabled + track"
    // "&$checked$disabled + $track": {
    //   backgroundColor: "#F4F4F4",
    // },
    // // ".SwtichBase.disabled .checked"
    // "&$disabled &$checked": {
    //   backgroundColor: "#FF0",
    // },
    // "&$disabled": {
    //   opacity: 0.25,
    // },
    // "&$disabled + $track": {
    //   opacity: 0.25,
    // },

    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "&:not($disabled) + $track": {
        backgroundColor: "var(--uiColor)",
        opacity: 1,
      },
    },
    "&$focusVisible $thumb": {
      backgroundColor: "var(--uiColor)",
      border: "1px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
    backgroundColor: "#FFF",
    border: "1px solid var(--uiColor)",
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: "#C9C9C9",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  let handleMouseClick = (e) => {
    let eventTarget = e.target.tagName;
    if (
      eventTarget === "SPAN" &&
      e.target.className.indexOf("SwitchButtonMidIcon") > -1
    ) {
      return props.midICONOnClick();
    } else if (eventTarget === "DIV") {
      if (props.disableLabelClick) return;
      if (props.onLabelClick) return props.onLabelClick();
    }
    // if (eventTarget === "INPUT"){}
    props.onClick();
  };
  let switchBtn = (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        disabled: classes.disabled,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...{ checked: props.checked }}
    />
  );
  return (
    <div onClick={handleMouseClick}>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: props.placeAtRight ? "row-reverse" : "row",
          justifyContent: "center",
          marginLeft: "10px",
          textAlign: "left",
        }}
      >
        {switchBtn}
        {props.needMidICON && (
          <span
            className={"icon_l SwitchButtonMidIcon " + props.midICONClassName}
            style={{ cursor: "pointer", float: "right", filter: "invert(0)" }}
          />
        )}
        <div
          style={{
            width: props.labelButtonAlignCenter ? "" : "100%",
            fontSize: `var(--commonFontSize)`,
            letterSpacing: "0.5px",
            color: "var(--selectFontColor)",
            textAlign: props.labelalignment,
            cursor:
              props.disabled || props.disableLabelClick ? "auto" : "pointer",
          }}
        >
          {props.label}
        </div>
      </span>
    </div>
  );
});
